import {UpdateEmailRepository} from '@domain/model/Account/UpdateEmail/UpdateEmailRepository';

const UpdateEmail = (repository: UpdateEmailRepository): ((email: string) => Promise<void>) => {
  return (email: string): Promise<void> => {
    return repository.updateEmail(email);
  };
};

export {UpdateEmail};
